
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M7.501 1.075A6.432 6.432 0 0113.925 7.5a6.432 6.432 0 01-6.424 6.425A6.433 6.433 0 011.075 7.5a6.433 6.433 0 016.426-6.425m0-1a7.425 7.425 0 100 14.85c4.1 0 7.424-3.324 7.424-7.425S11.601.075 7.501.075z"}}),_c('path',{attrs:{"d":"M9.979 6.148a.5.5 0 00-.707 0L8.01 7.412V3.164a.5.5 0 00-1 0v4.248L5.766 6.168a.5.5 0 00-.707.707l2.098 2.098a.5.5 0 00.707 0L9.98 6.856a.5.5 0 00-.001-.708zM10.346 11.101H4.675a.5.5 0 010-1h5.671a.5.5 0 010 1z"}})])
          )
        }
      }
    